
//
export const calculateAnnualDistance = (hoursOperating: number, hoursCharging: number, distancePerHour: number): number => {
  const totalHours = hoursOperating - hoursCharging;
  const distancePerDay = distancePerHour * totalHours;
  const distancePerYear = distancePerDay * 365;

  return distancePerYear;
}



// WEBPACK FOOTER //
// ./src/store/selectors/utilization/utils.ts